type Quote = {
	text: string;
	author: string;
	avatar: string;
};

export const quotes: Quote[] = [
	{
		text: "I made lots of progress on our project and was very proud and surprised by our speed and productivity. Everyone was invested in the team, and we even organized club dinners after meetings. ",
		author: "Cameron Leung",
		avatar: require("../assets/Images/Headshots/Cameron Leung.jpg"),
	},
	{
		text: "I’ve gained so many valuable software engineering skills/experiences that are highly applicable to the industry since joining Codify! Codify members are always supportive and helpful.",
		author: "Cady He",
		avatar: require("../assets/Images/Headshots/Cady He.jpeg"),
	},
	{
		text: "Codify’s diverse projects provide meaningful industry and leadership experience while fostering a tight-knit, supportive community.",
		author: "Rohan Kudchadker",
		avatar: require("../assets/Images/Headshots/SP25_Rohan Kudchadker.jpg")
	}
];
